<div class="flex h-full items-center">
  <proffeo-ui-date-range-picker
    [(value)]="rangeValue"
    [iconActive]="selectedTimeMode() === SelectedTimeReportTypeEnum.RANGE"
    appearance="icon"
  />
</div>
